import http from "../http-common";
/* eslint-disable */
class DPDService {
  dpdList(page, itemPerPage, keyword, dpw) {
    return http.get(
      "/dpd/list?page=" +
        page +
        "&item_per_page=" +
        itemPerPage +
        "&keyword=" +
        keyword +
        "&dpw_id=" +
        dpw,
      {
        headers: {
          "Content-type": "application/json",
          Authorization:
            "Bearer " + localStorage.getItem(process.env.VUE_APP_TOKEN_PREFIX),
        },
      },
    );
  }

  dpdListAllOnly() {
    return http.get(`/dpd-only/all`, {
      headers: {
        "Content-type": "application/json",
        Authorization:
          "Bearer " + localStorage.getItem(process.env.VUE_APP_TOKEN_PREFIX),
      },
    });
  }

  dpdListAll(dpwId) {
    return http.get(`/dpd/all?dpw_id=${dpwId}`, {
      headers: {
        "Content-type": "application/json",
        Authorization:
          "Bearer " + localStorage.getItem(process.env.VUE_APP_TOKEN_PREFIX),
      },
    });
  }

  create(data) {
    var bodyFormData = new FormData();
    bodyFormData.append("nama", data.nama);
    bodyFormData.append("alamat", data.alamat);

    if (data.selectedDpw && data.selectedDpw != undefined) {
      bodyFormData.append("dewan_pengurus_wilayah_id", data.selectedDpw.id);
    }

    return http.post("/dpd", bodyFormData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }

  update(id, data) {
    var bodyFormData = new FormData();
    bodyFormData.append("id", id);
    bodyFormData.append("nama", data.nama);
    bodyFormData.append("alamat", data.alamat);

    if (data.selectedDpw && data.selectedDpw != undefined) {
      bodyFormData.append("dewan_pengurus_wilayah_id", data.selectedDpw.id);
    }

    return http.put(`/dpd/${id}`, bodyFormData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }

  delete(id) {
    return http.delete(`/dpd/${id}`, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }
}

export default new DPDService();
